// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3VOls","importantInfo":"styles_importantInfo__3IQd0"};